/* eslint-disable @typescript-eslint/indent */
import { useLazyQuery } from '@netfront/apollo-providers';

import { GET_MURIQUI_PROJECT_WITH_DOWNGRADE_REQUEST } from './useGetMuriquiProject.graphql';
import {
  IGetMuriquiProjectQueryGraphQLResponse,
  IHandleGetMuriquiProjectParams,
  IUseGetMuriquiProject,
  IUseGetMuriquiProjectOptions,
} from './useGetMuriquiProject.interfaces';

const useGetMuriquiProject = (options?: IUseGetMuriquiProjectOptions): IUseGetMuriquiProject => {
  const { fetchPolicy, onCompleted, onError } = options ?? ({} as IUseGetMuriquiProjectOptions);

  const { handleQuery: executeGetMuriquiProject, isLoading = false } = useLazyQuery({
    apiName: 'muriqui',
    fetchPolicy: fetchPolicy ?? 'cache-and-network',
    // apollo-providers still calls onCompleted, with undefined data, when the request fails (e.g. a network error) and onError reports it
    onCompleted: (data?: IGetMuriquiProjectQueryGraphQLResponse) => {
      const project = data?.projects?.get;

      if (!onCompleted || !project) {
        return;
      }

      onCompleted({
        project,
      });
    },
    onError,
    query: GET_MURIQUI_PROJECT_WITH_DOWNGRADE_REQUEST,
  });

  // Also returns the project, so a caller can tell which request it belongs to: onCompleted runs for every response
  const handleGetMuriquiProject = async ({ projectId }: IHandleGetMuriquiProjectParams) => {
    // apollo-providers resolves to undefined when the request fails
    const data = (await executeGetMuriquiProject({
      projectId,
    })) as IGetMuriquiProjectQueryGraphQLResponse | undefined;

    return data?.projects?.get ?? undefined;
  };

  return {
    handleGetMuriquiProject,
    isLoading,
  };
};

export { useGetMuriquiProject };
